function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import ApiConstants from 'invision-core/src/api/constants';
import { ThunkHelper } from 'invision-core';
export var SEARCH_COUPON_REDEMPTIONS_CONSTANTS = {
  BEGIN: 'SEARCH_COUPON_REDEMPTIONS_BEGIN',
  SUCCESS: 'SEARCH_COUPON_REDEMPTIONS_SUCCESS',
  FAILURE: 'SEARCH_COUPON_REDEMPTIONS_FAILURE'
};
var SEARCH_COUPON_REDEMPTIONS_EVENTS = [SEARCH_COUPON_REDEMPTIONS_CONSTANTS.BEGIN, SEARCH_COUPON_REDEMPTIONS_CONSTANTS.SUCCESS, SEARCH_COUPON_REDEMPTIONS_CONSTANTS.FAILURE];
var searchCouponRedemptionsPromise = function searchCouponRedemptionsPromise(dispatch, customerId) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var languageHeader = arguments.length > 3 ? arguments[3] : undefined;
  var data = {
    PageSize: filter.pageSize,
    PageNumber: filter.pageNumber,
    SearchString: filter.searchString,
    CouponRedemptionCodeId: filter.couponRedemptionCodeId
  };
  return ThunkHelper(dispatch, SEARCH_COUPON_REDEMPTIONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchCouponRedemptions',
    data: data,
    headers: _defineProperty(_defineProperty({}, ApiConstants.CUSTOM_SUBSCRIBER_LANGUAGE_HEADER, languageHeader), ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var SEARCH_REDEMPTION_CODES_CONSTANTS = {
  BEGIN: 'SEARCH_REDEMPTION_CODES_BEGIN',
  SUCCESS: 'SEARCH_REDEMPTION_CODES_SUCCESS',
  FAILURE: 'SEARCH_REDEMPTION_CODES_FAILURE'
};
var SEARCH_REDEMPTION_CODES_EVENTS = [SEARCH_REDEMPTION_CODES_CONSTANTS.BEGIN, SEARCH_REDEMPTION_CODES_CONSTANTS.SUCCESS, SEARCH_REDEMPTION_CODES_CONSTANTS.FAILURE];
export var searchCouponRedemptions = function searchCouponRedemptions(customerId, filter, languageHeader) {
  return function (dispatch) {
    return searchCouponRedemptionsPromise(dispatch, customerId, filter, languageHeader);
  };
};
var searchRedemptionCodesPromise = function searchRedemptionCodesPromise(dispatch, customerId) {
  var filter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var data = {
    PageSize: filter.pageSize,
    PageNumber: filter.pageNumber,
    GrantEnd: filter.grantEnd,
    GrantStart: filter.grantStart,
    SearchString: filter.searchString,
    RedemptionStatus: filter.redemptionStatus,
    SortDirection: filter.sortDirection
  };
  return ThunkHelper(dispatch, SEARCH_REDEMPTION_CODES_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchRedemptionCodes',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var searchRedemptionCodes = function searchRedemptionCodes(customerId, filter) {
  return function (dispatch) {
    return searchRedemptionCodesPromise(dispatch, customerId, filter);
  };
};
export var SEARCH_GRANTABLE_COUPONS_CONSTANTS = {
  BEGIN: 'SEARCH_GRANTABLE_COUPONS_BEGIN',
  SUCCESS: 'SEARCH_GRANTABLE_COUPONS_SUCCESS',
  FAILURE: 'SEARCH_GRANTABLE_COUPONS_FAILURE'
};
export var SEARCH_GRANTABLE_COUPONS_EVENTS = [SEARCH_GRANTABLE_COUPONS_CONSTANTS.BEGIN, SEARCH_GRANTABLE_COUPONS_CONSTANTS.SUCCESS, SEARCH_GRANTABLE_COUPONS_CONSTANTS.FAILURE];
var searchCouponsPromise = function searchCouponsPromise(dispatch, filter) {
  var data = {
    CouponName: filter.couponName,
    PageSize: filter.pageSize,
    PageNumber: filter.pageNumber
  };
  return ThunkHelper(dispatch, SEARCH_GRANTABLE_COUPONS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/SearchCoupons',
    data: data
  });
};
export var searchGrantableCoupons = function searchGrantableCoupons(filter) {
  return function (dispatch) {
    return searchCouponsPromise(dispatch, filter);
  };
};
export var GRANT_COUPON_CONSTANTS = {
  BEGIN: 'GRANT_COUPON_BEGIN',
  SUCCESS: 'GRANT_COUPON_SUCCESS',
  FAILURE: 'GRANT_COUPON_FAILURE'
};
export var GRANT_COUPON_EVENTS = [GRANT_COUPON_CONSTANTS.BEGIN, GRANT_COUPON_CONSTANTS.SUCCESS, GRANT_COUPON_CONSTANTS.FAILURE];
var grantCouponPromise = function grantCouponPromise(dispatch, customerId) {
  var data = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return ThunkHelper(dispatch, GRANT_COUPON_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/GrantCoupon',
    data: data,
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId)
  }, {
    customerId: customerId
  });
};
export var grantCoupon = function grantCoupon(customerId, data) {
  return function (dispatch) {
    return grantCouponPromise(dispatch, customerId, data);
  };
};
export var SET_SELECTED_COUPON = 'SET_SELECTED_COUPON';
export var setSelectedCoupon = function setSelectedCoupon(payload) {
  return {
    type: SET_SELECTED_COUPON,
    payload: payload
  };
};
export var RETRIEVE_REDEMPTION_CODE_DETAILS_CONSTANTS = {
  BEGIN: 'RETRIEVE_REDEMPTION_CODE_DETAILS_BEGIN',
  SUCCESS: 'RETRIEVE_REDEMPTION_CODE_DETAILS_SUCCESS',
  FAILURE: 'RETRIEVE_REDEMPTION_CODE_DETAILS_FAILURE'
};
var RETRIEVE_REDEMPTION_CODE_DETAILS_EVENTS = [RETRIEVE_REDEMPTION_CODE_DETAILS_CONSTANTS.BEGIN, RETRIEVE_REDEMPTION_CODE_DETAILS_CONSTANTS.SUCCESS, RETRIEVE_REDEMPTION_CODE_DETAILS_CONSTANTS.FAILURE];
var retrieveRedemptionCodeDetailsPromise = function retrieveRedemptionCodeDetailsPromise(dispatch, customerId, couponRedemptionCodeId) {
  return ThunkHelper(dispatch, RETRIEVE_REDEMPTION_CODE_DETAILS_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/RetrieveRedemptionCode',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: {
      Id: couponRedemptionCodeId
    }
  }, {
    couponRedemptionCodeId: couponRedemptionCodeId
  });
};
export var retrieveRedemptionCodeDetails = function retrieveRedemptionCodeDetails(customerId, couponRedemptionCodeId) {
  return function (dispatch) {
    return retrieveRedemptionCodeDetailsPromise(dispatch, customerId, couponRedemptionCodeId);
  };
};
export var SET_CURRENT_GRANT_COUPONS_PAGE = 'SET_CURRENT_GRANT_COUPONS_PAGE';
export var setCurrentGrantCouponsPage = function setCurrentGrantCouponsPage(page) {
  return {
    type: SET_CURRENT_GRANT_COUPONS_PAGE,
    payload: page
  };
};
export var SET_GRANT_COUPONS_NAME_FILTER = 'SET_GRANT_COUPONS_NAME_FILTER';
export var setGrantCouponsNameFilter = function setGrantCouponsNameFilter(name) {
  return {
    type: SET_GRANT_COUPONS_NAME_FILTER,
    payload: name
  };
};
export var SET_CURRENT_GRANTED_COUPONS_PAGE = 'SET_CURRENT_GRANTED_COUPONS_PAGE';
export var setCurrentGrantedCouponsPage = function setCurrentGrantedCouponsPage(page) {
  return {
    type: SET_CURRENT_GRANTED_COUPONS_PAGE,
    payload: page
  };
};
export var SET_GRANTED_COUPONS_GRANT_DATE_END_FILTER = 'SET_GRANTED_COUPONS_GRANT_DATE_END_FILTER';
export var setGrantedCouponsGrantDateEndFilter = function setGrantedCouponsGrantDateEndFilter(date) {
  return {
    type: SET_GRANTED_COUPONS_GRANT_DATE_END_FILTER,
    payload: date
  };
};
export var SET_GRANTED_COUPONS_GRANT_DATE_START_FILTER = 'SET_GRANTED_COUPONS_GRANT_DATE_START_FILTER';
export var setGrantedCouponsGrantDateStartFilter = function setGrantedCouponsGrantDateStartFilter(date) {
  return {
    type: SET_GRANTED_COUPONS_GRANT_DATE_START_FILTER,
    payload: date
  };
};
export var SET_GRANTED_COUPONS_NAME_OR_CODE_FILTER = 'SET_GRANTED_COUPONS_NAME_OR_CODE_FILTER';
export var setGrantedCouponsNameOrCodeFilter = function setGrantedCouponsNameOrCodeFilter(nameOrCode) {
  return {
    type: SET_GRANTED_COUPONS_NAME_OR_CODE_FILTER,
    payload: nameOrCode
  };
};
export var SET_GRANTED_COUPONS_REDEMPTION_STATUS_FILTER = 'SET_GRANTED_COUPONS_REDEMPTION_STATUS_FILTER';
export var setGrantedCouponsRedemptionStatusFilter = function setGrantedCouponsRedemptionStatusFilter(redemptionStatus) {
  return {
    type: SET_GRANTED_COUPONS_REDEMPTION_STATUS_FILTER,
    payload: redemptionStatus
  };
};
export var SET_GRANTED_COUPONS_PAGE_SIZE_PREFERENCE = 'SET_GRANTED_COUPONS_PAGE_SIZE_PREFERENCE';
export var setGrantedCouponsPageSizePreference = function setGrantedCouponsPageSizePreference(pageSize) {
  return {
    type: SET_GRANTED_COUPONS_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var SET_COUPONS_PAGE_SIZE_PREFERENCE = 'SET_COUPONS_PAGE_SIZE_PREFERENCE';
export var setPageSizePreference = function setPageSizePreference(pageSize) {
  return {
    type: SET_COUPONS_PAGE_SIZE_PREFERENCE,
    payload: pageSize
  };
};
export var RESEND_COUPON_REDEMPTION_CODE = {
  BEGIN: 'RESEND_COUPON_REDEMPTION_CODE_BEGIN',
  SUCCESS: 'RESEND_COUPON_REDEMPTION_CODE_SUCCESS',
  FAILURE: 'RESEND_COUPON_REDEMPTION_CODE_FAILURE'
};
var RESEND_COUPON_REDEMPTION_CODE_EVENTS = [RESEND_COUPON_REDEMPTION_CODE.BEGIN, RESEND_COUPON_REDEMPTION_CODE.SUCCESS, RESEND_COUPON_REDEMPTION_CODE.FAILURE];
export var resendRedemptionCodePromise = function resendRedemptionCodePromise(dispatch, customerId, couponRedemptionCode, recipientEmailAddress, recipientName) {
  var data = {
    RedemptionCode: couponRedemptionCode
  };
  if (recipientEmailAddress) {
    data.RecipientEmailAddress = recipientEmailAddress;
  }
  if (recipientName) {
    data.RecipientName = recipientName;
  }
  return ThunkHelper(dispatch, RESEND_COUPON_REDEMPTION_CODE_EVENTS, {
    method: 'post',
    url: 'SubscriberManagement/ResendRedemptionCode',
    headers: _defineProperty({}, ApiConstants.SUBSCRIBER_ID_HEADER, customerId),
    data: data
  });
};
export var resendRedemptionCode = function resendRedemptionCode(customerId, couponRedemptionCodeId) {
  var recipientEmailAddress = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
  var recipientName = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
  return function (dispatch) {
    return resendRedemptionCodePromise(dispatch, customerId, couponRedemptionCodeId, recipientEmailAddress, recipientName);
  };
};
export var EMPTY_COUPONS_LIST = 'EMPTY_COUPONS_LIST';
export var emptyCouponsList = function emptyCouponsList() {
  return {
    type: EMPTY_COUPONS_LIST
  };
};
export var REMOVE_COUPONS_FILTER = 'REMOVE_COUPONS_FILTER';
export var removeCouponsFilter = function removeCouponsFilter() {
  return {
    type: REMOVE_COUPONS_FILTER
  };
};